import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, PageKey } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: PageKey[] = [
  LocationVarKey.AccessGateCode1,
  LocationVarKey.AccessGateCode2,
  LocationVarKey.AccessGateCode3,
  {
    key: LocationVarKey.FMSGateCodeChannel,
    hideIf: IS_NOT_EQUAL(LocationVarKey.HasGateCodeIntegration, "1")
  },
  {
    key: LocationVarKey.FMSGateCodeChannelSMSMessage,
    hideIf: IF_ANY([IS_EQUAL(LocationVarKey.FMSGateCodeChannel, "Email"), IS_NOT_EQUAL(LocationVarKey.HasGateCodeIntegration, "1")])
  }
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        Gate Code
      </PageHeader>

      <TextAreaRow {...page} marginTop label=" Message 1" keyName={LocationVarKey.AccessGateCode1} />
      <TextAreaRow {...page} marginTop label=" Message 2" keyName={LocationVarKey.AccessGateCode2} />
      <TextAreaRow
        {...page}
        marginTop
        label=" Message 3 (Optional)"
        keyName={LocationVarKey.AccessGateCode3}
        enableSwitchVar={LocationVarKey.AccessGateCode3Enabled}
      />

      <SectionHeader {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasGateCodeIntegration, "1")}>
        Delivery Settings
      </SectionHeader>
      <DropdownRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.HasGateCodeIntegration, "1")}
        marginTop
        label=" Send Gate Code to:"
        keyName={LocationVarKey.FMSGateCodeChannel}
        options={[
          {
            label: "SMS",
            value: "SMS"
          },
          {
            label: "Email",
            value: "Email"
          },
          {
            label: "SMS and Email",
            value: "Both"
          }
        ]}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.FMSGateCodeChannel, "Email") && IS_NOT_EQUAL(LocationVarKey.HasGateCodeIntegration, "1")}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.FMSGateCodeChannelSMSMessage}
      />
    </>
  );
}
